













import { Vue, Component, Prop } from 'vue-property-decorator';
import ActionButtons from './ActionButtons.vue';

@Component({
  components: {
    ActionButtons,
  },
})
export default class DeleteModal extends Vue {
  @Prop(Function) private confirmHandler: any;
  @Prop(Function) private cancelHandler: any;
  @Prop(String) private alertText!: string;
  @Prop(Boolean) private isVisible!: boolean;
}
